export const ccaResultsDataSelector = state => state.ccaResults.resultsData;
export const ccaResultsErrorSelector = state => state.ccaResults.error;
export const isFetchingCCAResultsSelector = state => state.ccaResults.isFetching;
